import { LiveUpdateService } from './services/core/live-update.service';
import { AsyncPipe, CommonModule, NgIf, NgOptimizedImage } from '@angular/common';
import { Component, effect } from '@angular/core';
import { RouterOutlet, Router  } from '@angular/router';
import { App } from '@capacitor/app';

import {
  IonApp,
  IonButton,
  IonIcon,
  IonProgressBar,
  IonRouterOutlet,
  IonSpinner,
} from '@ionic/angular/standalone';

import { AlertController, Platform } from '@ionic/angular';

import { Observable } from 'rxjs';

import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';

import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

import { NetworkStatusBannerComponent } from './components/network-status-banner/network-status-banner.component';
import { TermsBlockerComponent } from './components/terms-blocker/terms-blocker.component';
import { DebugPanelComponent } from './debug/debug-panel.component'
import { AuthService } from './services/auth/auth.service';
import { DataModeService } from './services/core/data-mode.service'; // Mode service
import { PushTokenService } from './services/account/push-token.service';
import { SyncUiService } from './services/core/sync-ui.service';
import { TermsService } from './services/account/terms.service';
import { ThemeService } from './services/core/theme.service';
//import { MainMenuComponent } from './components/menus/main-menu/main-menu.component';

addIcons({ 'close-outline': closeOutline });



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    IonApp,
    IonButton,
    IonIcon,
    IonProgressBar,
    IonRouterOutlet,
    IonSpinner,
    TermsBlockerComponent,
    NgIf,
    AsyncPipe,
    DebugPanelComponent,
    NetworkStatusBannerComponent,

  ],
})
export class AppComponent {
  private updatePromptStarted = false;
  blockingRequired$!: Observable<boolean>;
  constructor(
    private platform: Platform,
    private router: Router,


    private dataMode: DataModeService, // Data mode initialiser+
    private push: PushTokenService,
    public syncUi: SyncUiService,
    private termsService: TermsService,
    private theme: ThemeService,
    private liveUpdates: LiveUpdateService,
    private alerts: AlertController,
  ) {
    effect(() => {
      if (this.liveUpdates.updateReady()) void this.presentUpdatePrompt();
    });
    this.blockingRequired$ = this.termsService.blockingRequired$;
    this.platform.ready().then(() => {
      void this.initStatusBar();
      this.liveUpdates.start();
    }); // wait for Ionic/Cordova/Capacitor bridge

    push.attachListenersOnce();
    this.setupDeepLinks(); //listen for deeplinks
    this.theme.init();

  }

  /** Reserve before awaiting Ionic to prevent simultaneous prompts. */
  private async presentUpdatePrompt(): Promise<void> {
    if (this.updatePromptStarted) return;
    this.updatePromptStarted = true;
    try {
      const alert = await this.alerts.create({
        header: 'App update ready',
        message: 'A new version of the app has been downloaded and needs to be applied. The app will restart briefly.',
        backdropDismiss: false,
        buttons: [{ text: 'Update now', handler: () => {
          void this.liveUpdates.reloadToUpdate();
          // Keep the action available for retry if reload fails.
          return false;
        } }],
      });
      await alert.present();
    } catch (error) {
      this.updatePromptStarted = false;
      console.warn('Live update prompt could not be presented', error);
    }
  }

  /** Bootstraps app-wide singletons */
  async ngOnInit(): Promise<void> {
    await this.dataMode.init(); // Load override + compute effective mode
  }

  // Ensure status bar does NOT overlap the WebView (fixes Pixel 7 “battery/time gone” + header offset issues)
  // Configure the native status bar safely (prevents content under status bar on Android)
  private async initStatusBar(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;

    try {
      await StatusBar.setOverlaysWebView({ overlay: false }); // key line
      await StatusBar.setBackgroundColor({ color: '#98BA65' }); // your green
      await StatusBar.setStyle({ style: Style.Dark }); // dark icons on light background
    } catch {
      // ignore
    }
  }

  private setupDeepLinks() {
    App.addListener('appUrlOpen', (event) => {
      const url = event.url;

      if (!url) return;

      // Handle only our https universal/app links - does not affect OAuth
      if (!url.startsWith('https://assessor.myaba.co.uk/')) return;

      const parsed = new URL(url);
      const path = parsed.pathname + parsed.search;

      console.log('Deep link received:', path);

      // Navigate inside Angular
      setTimeout(() => this.router.navigateByUrl(path), 0);
    });
  }
}
